import type {VariantProps} from 'class-variance-authority';
import {ChevronDown} from 'lucide-react';
import {Collapsible as CollapsiblePrimitive} from 'radix-ui';

import {cn} from '@/utils/ui';

import {
  collapsibleContentVariants,
  collapsibleTriggerVariants,
  collapsibleVariants,
} from './collapsible-variants';

function Collapsible({
  className,
  variant,
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.Root> &
  VariantProps<typeof collapsibleVariants>) {
  return (
    <CollapsiblePrimitive.Root
      data-slot="collapsible"
      className={cn(collapsibleVariants({variant}), className)}
      {...props}
    />
  );
}

function CollapsibleTrigger({
  className,
  children,
  variant,
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.CollapsibleTrigger> &
  VariantProps<typeof collapsibleTriggerVariants>) {
  return (
    <CollapsiblePrimitive.CollapsibleTrigger
      data-slot="collapsible-trigger"
      className={cn(collapsibleTriggerVariants({variant}), className)}
      {...props}
    >
      <ChevronDown className="size-4 shrink-0 transition-transform" />
      {children}
    </CollapsiblePrimitive.CollapsibleTrigger>
  );
}

function CollapsibleContent({
  className,
  variant,
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.CollapsibleContent> &
  VariantProps<typeof collapsibleContentVariants>) {
  return (
    <CollapsiblePrimitive.CollapsibleContent
      data-slot="collapsible-content"
      className={cn(collapsibleContentVariants({variant}), className)}
      {...props}
    />
  );
}

export {Collapsible, CollapsibleContent, CollapsibleTrigger};
